import _ from 'lodash'

export const SET_ACTIVE_TRAIN = 'SET_ACTIVE_TRAIN'
export const RESET_ACTIVE_TRAIN = 'RESET_ACTIVE_TRAIN'

export const setActiveTrain = (trainId) => (
  dispatch,
  getState
) => {
  const trains = _.get(getState(), 'trainsData.data', {})
  const activeTrain = trains[trainId]
  if (activeTrain) {
    dispatch({ type: SET_ACTIVE_TRAIN, payload: activeTrain })
  }
}

export const resetActiveTrain = () => (dispatch) => {
  dispatch({ type: RESET_ACTIVE_TRAIN })
}
